import axios from 'axios'

const request = axios.create({
  baseURL: 'https://wechat.ceba.ceshiren.com/dev/backend',
})

export default request